module.exports = __webpack_public_path__ + "assets/img/pexels-photo-302899.95a9b7e3.png";